function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m7.4477 9.7915v13.458h6.0917v-18.438z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.4477 9.7915v13.458h6.0917v-18.438z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m35.365 9.8738v13.54h-6.0917v-18.603z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(2.9162)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
}, React.createElement("path", {
  d: "m28.498 9.1155v2.7456"
}), React.createElement("path", {
  d: "m28.498 14.207v2.6399"
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m32.239 23.414-2.9655 4e-6v-18.603l3.0633 2.72",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m17.326 0.53134v1.8109h7.7381v-1.8109z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m17.467 0.53134h7.9143v1.8109h-7.9143z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m15.455 1.5312v1.3765h11.914v-1.3765z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m15.42 1.5312h12.09v2.2926h-12.09z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m22.971 15.224v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm-3.0859-2.7986h16.064v20.414h-6.2141v-3.416h-3.6355v3.416h-6.2141z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m22.971 15.224v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm-3.0859-2.7986h16.064v20.414h-6.2141v-3.416h-3.6355v3.416h-6.2141z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m6.5462 18.64 0.12115 0.20578c1.2519 1.2758 2.9479 2.0578 4.8459 2.0578 1.9384 0 3.6344-0.78197 4.8863-2.0578l0.12115-0.20578 1.0096 0.24694c2.9479 1.2347 4.9671 4.1568 4.9671 7.6139v6.9143l-3.5537 1.317c-2.3826 0.57619-4.8863 0.86428-7.4304 0.86428-2.5037 0-5.0075-0.2881-7.39-0.86428l-3.5941-1.317v-6.9143c0-3.4571 2.0595-6.3792 5.0075-7.6139z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.0075 0 0 1.0268 -1.9746 -.044853)",
  d: "m8.4571 18.197 0.12024 0.2004c1.2425 1.2425 2.9259 2.004 4.8097 2.004 1.9239 0 3.6073-0.76154 4.8498-2.004l0.12024-0.2004 1.002 0.24048c2.9259 1.2024 4.93 4.0482 4.93 7.415v6.7336l-3.5271 1.2826c-2.3648 0.56113-4.8498 0.8417-7.3749 0.8417-2.485 0-4.97-0.28057-7.3348-0.8417l-3.5672-1.2826v-6.7336c0-3.3668 2.0441-6.2125 4.97-7.415z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.78652
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m4.729 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m4.729 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m35.443 4.4823h18.533l5.5721 5.591v23.453h-24.105z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.2089 0 0 1.2077 .55678 -5.4169)",
  d: "m28.858 8.1966h15.331l4.6093 4.6293v19.419h-19.94z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.66209
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m59.524 10.001h-5.5721v-5.5668z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m59.524 10.001h-5.5721v-5.5668z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m44.915 24.48h4.7968v4.1025h-4.7968zm2.9799-12.972c1.6959 0 3.0768 0.35571 4.1185 1.0434 1.4294 0.94856 2.1319 2.2054 2.1319 3.7705 0 0.64028-0.16959 1.2568-0.53298 1.8734-0.38762 0.59285-1.1144 1.3517-2.2531 2.2054-0.79948 0.61656-1.3082 1.1146-1.502 1.4703-0.21804 0.37942-0.31495 0.8537-0.31495 1.4466h-4.4577v-0.42685c0-0.73513 0.07268-1.3517 0.24226-1.8023 0.16958-0.47428 0.43608-0.87742 0.77525-1.2806 0.33917-0.37942 1.1144-1.0434 2.3015-1.992 0.62989-0.52171 0.94483-0.97227 0.94483-1.3991 0-0.42685-0.12113-0.73513-0.38762-0.97227-0.24227-0.23714-0.62989-0.35571-1.1629-0.35571s-0.99329 0.18971-1.3567 0.54542c-0.3634 0.35571-0.60566 0.97227-0.70257 1.8734l-4.5788-0.54542c0.16959-1.6363 0.77525-2.9405 1.8412-3.9602 1.066-0.99599 2.6891-1.494 4.8938-1.494z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m44.915 24.48h4.7968v4.1025h-4.7968zm2.9799-12.972c1.6959 0 3.0768 0.35571 4.1185 1.0434 1.4294 0.94856 2.1319 2.2054 2.1319 3.7705 0 0.64028-0.16959 1.2568-0.53298 1.8734-0.38762 0.59285-1.1144 1.3517-2.2531 2.2054-0.79948 0.61656-1.3082 1.1146-1.502 1.4703-0.21804 0.37942-0.31495 0.8537-0.31495 1.4466h-4.4577v-0.42685c0-0.73513 0.07268-1.3517 0.24226-1.8023 0.16958-0.47428 0.43608-0.87742 0.77525-1.2806 0.33917-0.37942 1.1144-1.0434 2.3015-1.992 0.62989-0.52171 0.94483-0.97227 0.94483-1.3991 0-0.42685-0.12113-0.73513-0.38762-0.97227-0.24227-0.23714-0.62989-0.35571-1.1629-0.35571s-0.99329 0.18971-1.3567 0.54542c-0.3634 0.35571-0.60566 0.97227-0.70257 1.8734l-4.5788-0.54542c0.16959-1.6363 0.77525-2.9405 1.8412-3.9602 1.066-0.99599 2.6891-1.494 4.8938-1.494z",
  fill: "none",
  stroke: "#002060",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var SvgMenuClientQuote = function SvgMenuClientQuote(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuClientQuote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-Client-Quote.3b98ec9d.svg";
export { ForwardRef as ReactComponent };